import { Paper, Typography } from "@mui/material";
import CartItem from "./cartItem";
import { getItemOffer } from "../../Utils/orderTotals";
const CartDetails = ({ items, itemOffers }) => {
  return (
    <>
      <Paper
        variant="none"
        square
        style={{
          padding: "0.3rem 0.7rem 0.4rem",
          marginTop: "0.4rem",
          maxHeight: "36vh",
          overflowY: "auto",
        }}
      >
        {items.length !== 0 ? (
          items.map((item, index) => (
            <CartItem
              key={item.orderDetId}
              item={item}
              offer={getItemOffer(itemOffers, item, index)}
            />
          ))
        ) : (
          <Typography variant="subtitle1" align="center" sx={{ color: "#8296b3", py: 3 }}>
            Add products to start this sale
          </Typography>
        )}
      </Paper>
    </>
  );
};

export default CartDetails;